module.exports = __webpack_public_path__ + "img/vipon.00d41872.svg";